import { useEffect, useRef, useState } from 'react';
import { cashMessage } from './cashMessages';
export function useCashPaymentReadiness({ client, input, authority, locale, onAccessDenied }) {
    const signature = input ? JSON.stringify(input) : '', current = useRef({ client, signature, authority, generation: 0 }), mounted = useRef(true);
    if (current.current.client !== client || current.current.signature !== signature || current.current.authority !== authority)
        current.current = { client, signature, authority, generation: current.current.generation + 1 };
    const [result, setResult] = useState(null), [loading, setLoading] = useState(false), [error, setError] = useState(''), [accessDenied, setAccessDenied] = useState(false);
    useEffect(() => { mounted.current = true; return () => { mounted.current = false; current.current.generation++; }; }, []);
    const refresh = async () => { if (!input || !client.paymentReadiness) {
        setLoading(false);
        return null;
    } ; if (current.current.client !== client || current.current.signature !== signature || current.current.authority !== authority)
        return null; const context = { client, signature, authority, generation: ++current.current.generation }; setLoading(true); setError(''); try {
        const value = await client.paymentReadiness(input);
        if (!mounted.current || !client.isCurrent() || Object.keys(context).some(key => context[key] !== current.current[key]))
            return null;
        setAccessDenied(false);
        setResult({ client, signature, authority, value });
        return value;
    }
    catch (cause) {
        if (!mounted.current || !client.isCurrent() || current.current.generation !== context.generation)
            return null;
        setResult(null);
        const fault = client.failure(cause);
        if (fault.status === 401 || fault.status === 403) {
            setAccessDenied(true);
            onAccessDenied?.();
        }
        ;
        setError(cashMessage(locale, fault.message, fault.code));
        return null;
    }
    finally {
        if (mounted.current && current.current.generation === context.generation)
            setLoading(false);
    } };
    useEffect(() => { if (!input) {
        setResult(null);
        setError('');
        setLoading(false);
        return;
    } ; void refresh(); }, [client, signature, authority]);
    return { value: client.isCurrent() && result?.client === client && result.signature === signature && result.authority === authority ? result.value : null, loading, error, accessDenied, refresh };
}
